module.exports = __webpack_public_path__ + "img/arrow-round.1b6fdd0a.svg";